export default __webpack_public_path__ + "static/media/homeicon.70a95172.svg";